/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2TaskMoveIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2TaskMoveIcon({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2TaskMoveIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 48,
  height = 48,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#3994C1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2TaskMoveIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 48 48"
 style={{'--as-1-Z2nh8Tm': alignSelf,'--mt-2-Z2nh8Tm': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z2nh8Tm': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z2nh8Tm': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z2nh8Tm': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z2nh8Tm': opacity,'--w-10-Z2nh8Tm': typeof width === 'number' ? `${width}px` : width,'--h-11-Z2nh8Tm': typeof height === 'number' ? `${height}px` : height,'--f-12-Z2nh8Tm': fill,'--a-7-Z2nh8Tm': isAnimated ? animation : "none",'--sd-8-Z2nh8Tm': isAnimated ? strokeDashoffset : 0,'--sd-9-Z2nh8Tm': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2TaskMoveIcon.SvgPath"
  data-view-path={viewPath}
 d="M12.797 6.857v1.43c0 3.55 2.92 6.427 6.522 6.427h8.696c3.601 0 6.52-2.878 6.521-6.428V6.857h1.45c2.401 0 4.348 1.919 4.348 4.286v28.57c0 2.368-1.947 4.287-4.348 4.287H11.348C8.946 44 7 42.08 7 39.714V11.143c0-2.367 1.947-4.285 4.348-4.286h1.449zM26.15 22.252a1.613 1.613 0 00-2.753 1.14v3.226h-5.914a2.15 2.15 0 100 4.3h5.914v3.227a1.613 1.613 0 002.753 1.14l5.377-5.376c.63-.63.63-1.651 0-2.281l-5.377-5.376zM28.015 4c1.6 0 2.898 1.28 2.898 2.857v1.43c0 1.577-1.298 2.856-2.898 2.856h-8.696c-1.6 0-2.898-1.28-2.898-2.857V6.857C16.42 5.28 17.718 4 19.319 4h8.696z"
 style={{'--f-12-Z2nh8Tm': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}